import { Tooltip } from 'antd';
import React, { FC } from 'react';
import Button from '../../Button/Button';
import styles from './SearchForm.module.scss';

type Props = {
  title: string | JSX.Element;
  disabled: boolean;
  tooltip: string;
  onClick: (e: ButtonSubmitEvent) => void;
};

export const SearchButton: FC<Props> = ({ title, tooltip, disabled, onClick }) => {
  return (
    <Tooltip placement='bottom' title={tooltip}>
      <div>
        <Button className={styles.searchButton} onClick={onClick} type='submit' disabled={disabled} title={title} />
      </div>
    </Tooltip>
  );
};

export default SearchButton;
